/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type WizardHeartbeatMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type WizardHeartbeatMutation = (
  { __typename?: 'Mutation' }
  & { wizardHeartbeat: Types.Maybe<{ __typename: 'HeartbeatResult' }> }
);


export const WizardHeartbeatDocument = gql`
    mutation wizardHeartbeat {
  wizardHeartbeat {
    __typename
  }
}
    `;
export type WizardHeartbeatMutationFn = Apollo.MutationFunction<WizardHeartbeatMutation, WizardHeartbeatMutationVariables>;

/**
 * __useWizardHeartbeatMutation__
 *
 * To run a mutation, you first call `useWizardHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardHeartbeatMutation, { data, loading, error }] = useWizardHeartbeatMutation({
 *   variables: {
 *   },
 * });
 */
export function useWizardHeartbeatMutation(baseOptions?: Apollo.MutationHookOptions<WizardHeartbeatMutation, WizardHeartbeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardHeartbeatMutation, WizardHeartbeatMutationVariables>(WizardHeartbeatDocument, options);
      }
export type WizardHeartbeatMutationHookResult = ReturnType<typeof useWizardHeartbeatMutation>;
export type WizardHeartbeatMutationResult = Apollo.MutationResult<WizardHeartbeatMutation>;
export type WizardHeartbeatMutationOptions = Apollo.BaseMutationOptions<WizardHeartbeatMutation, WizardHeartbeatMutationVariables>;